import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b0bc456a"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner-wrapper"
}, null, -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-wrapper center flex-column"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "font-h2"
}, "進擊的 Demi Trader !"), /*#__PURE__*/_createElementVNode("div", {
  class: "lh-base font-h3 bg-white p-2"
}, "多重賦能限量發行中")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _hoisted_2], 64);
}